import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="elegant-footer">
      <div className="footer-content">
        <p>Web creada por <span className="company-name">Sec-Hat Technologies | https://sec-hat.com</span></p>
      </div>
    </footer>
  );
};

export default Footer;